// (c) chaehongee. Confidential and proprietary.

import { useTranslation } from 'react-i18next'
import { updateUserPreferences } from '../../services/user'
import { useAuth } from '../../store/hooks/useAuth'
import styles from './LanguageSwitcher.module.css'

const SUPPORTED_LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'ko', label: '한국어' },
] as const

interface LanguageSwitcherProps {
    variant?: 'default' | 'compact'
}

export function LanguageSwitcher({ variant = 'default' }: LanguageSwitcherProps) {
    const { i18n } = useTranslation()
    const { user } = useAuth()

    const handleLanguageChange = async (langCode: string) => {
        if (i18n.language === langCode) return

        await i18n.changeLanguage(langCode)

        if (user) {
            try {
                await updateUserPreferences({ locale: langCode })
            } catch (err) {
                console.error('Failed to persist locale preference:', err)
            }
        }
    }

    return (
        <div className={`${styles.root} ${variant === 'compact' ? styles.compact : ''}`}>
            {SUPPORTED_LANGUAGES.map((lang) => (
                <button
                    key={lang.code}
                    type="button"
                    className={styles.langButton}
                    data-active={i18n.language === lang.code}
                    onClick={() => handleLanguageChange(lang.code)}
                >
                    {lang.label}
                </button>
            ))}
        </div>
    )
}
